// CancelledOrders.js
import React, { useEffect, useState } from "react";
import { Table, Spin, message, Typography } from "antd";
import axios from "axios";
import SummaryApi from "../../../common/index";

const { Title } = Typography;

function CancelledOrders({ seller, token }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCancelledOrders();
  }, []);

  const fetchCancelledOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(SummaryApi.getCancelledOrders.url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            sellerId: seller.id,
          },
        }
      );
      setOrders(response.data.orders || []);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch cancelled orders");
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Order ID",
      dataIndex: "order_id",
      key: "order_id",
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: "Amount",
      dataIndex: "total_price",
      key: "total_price",
      render: (total_price) => `₹${Number(total_price ||0).toFixed(2)}`,
    },
    {
      title: "Cancelled On",
      dataIndex: "cancelled_at",
      key: "cancelled_at",
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: "Reason",
      dataIndex: "cancel_reason",
      key: "cancel_reason",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Title level={3} style={{ marginBottom: "20px" }}>
        Cancelled Orders
      </Title>
      {loading ? (
        <Spin tip="Loading cancelled orders..." size="large" />
      ) : (
        <Table
          dataSource={orders}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      )}
    </div>
  );
}

export default CancelledOrders;
